import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';

import { BaseComponent } from '../../../core';
import { TimeInterval } from '../../../services';
import { DateUtil } from '../../../utils/date.util';

@Component({ template: '' })
export abstract class TimeIntervalPickerBaseComponent extends BaseComponent implements OnChanges, OnInit {
  @Input() timeInterval: TimeInterval;
  @Output() timeIntervalChange: EventEmitter<TimeInterval>;

  private _from: Date;
  private _to: Date;
  private _isOpenAllDay = false;
  private _inherit = false;
  private initialized = false;

  constructor(private cd: ChangeDetectorRef) {
    super();
    this.timeIntervalChange = new EventEmitter<TimeInterval>();
  }

  get from(): Date {
    return this._from;
  }
  set from(value: Date) {
    if (!value || value === this._from) {
      return;
    }
    this._from = value;
    if (this.initialized) {
      this.updateTimeInterval();
    }
    this.cd.markForCheck();
  }

  get to(): Date {
    return this._to;
  }
  set to(value: Date) {
    this._to = value;
    if (this.initialized) {
      this.updateTimeInterval();
    }
    this.cd.markForCheck();
  }

  get isOpenAllDay(): boolean {
    return this._isOpenAllDay;
  }
  @Input() set isOpenAllDay(value: boolean) {
    if (value) {
      this.from = new Date(2000, 0, 1, 0);
      this.to = new Date(2000, 0, 1, 24);
      this.updateTimeInterval();
    }
    this._isOpenAllDay = value;
    this.cd.markForCheck();
  }

  get inherit(): boolean {
    return this._inherit;
  }
  @Input() set inherit(value: boolean) {
    if (value) {
      this.from = new Date(0);
      this.to = new Date(0);
      this.updateTimeInterval();
    }
    this._inherit = value;
    this.cd.markForCheck();
  }

  ngOnInit() {
    this.initialized = true;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!changes.timeInterval || !this.timeInterval) {
      return;
    }
    this.from = this.timeToDate(this.timeInterval.from);
    this.to = this.timeToDate(this.timeInterval.to);
  }

  updateTimeInterval() {
    if (!this.from || !this.to) {
      return;
    }
    const fromTime = DateUtil.dateToTimeOfDay(this.from);
    let toTime = DateUtil.dateToTimeOfDay(this.to);

    if (toTime <= fromTime) {
      toTime += 24 * 60;
    }

    this.timeInterval.from = fromTime;
    this.timeInterval.to = toTime;

    this.timeIntervalChange.emit(this.timeInterval);
  }

  private timeToDate(time: number): Date {
    if (!time) {
      return undefined;
    }
    const date = new Date(0);
    date.setHours(Math.floor(time / 60));
    date.setMinutes(time % 60);

    return date;
  }
}
